import { render, staticRenderFns } from "./loadingModal.template.vue?vue&type=template&id=5d58b44e&scoped=true&"
var script = {}
import style0 from "./loadingModal.template.vue?vue&type=style&index=0&id=5d58b44e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d58b44e",
  null
  
)

export default component.exports